import { FormControl, FormLabel, Switch } from '@chakra-ui/react';

export function TexasSwitch({
  checked,
  label,
  labelColor,
  onChange,
}: {
  checked: boolean;
  label: string;
  labelColor?: string;
  onChange: (checked: boolean) => void;
}) {
  return (
    <FormControl w="fit-content" display="flex" alignItems="center" gap={2}>
      <Switch
        isChecked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <FormLabel
        color={labelColor ?? (checked ? 'white' : 'whiteAlpha.600')}
        _light={
          labelColor
            ? { color: labelColor }
            : { color: checked ? 'texas.bg.900' : 'blackAlpha.700' }
        }
        mb={0}
      >
        {label}
      </FormLabel>
    </FormControl>
  );
}
